"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAddressUsingIP = exports.addressFromGeoLocation = exports.getBrowserLocation = void 0;

var axios_1 = __importDefault(require("axios"));

var Enums_1 = require("../Enums");

var typeHelpers_1 = require("../Helpers/typeHelpers");
/**
* @desc - Attempts to query users geo location on CLIENT SIDE , note this an async call
* @remarks
*  User  can turn off location on system level or browser site settings level
*  if catch error, will return {error:"error message"}
* @param timeout:number, specifying timeout length(threshold)
* @returns Object Literal
    {longitude:number, latituded:number} or {error:string}
*/


var getBrowserLocation = function getBrowserLocation() {
  var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
  return new Promise(function (resolve) {
    var _a;

    (_a = navigator === null || navigator === void 0 ? void 0 : navigator.geolocation) === null || _a === void 0 ? void 0 : _a.getCurrentPosition(function (position) {
      var _position$coords = position.coords,
          longitude = _position$coords.longitude,
          latitude = _position$coords.latitude;
      resolve({
        longitude: longitude,
        latitude: latitude
      });
    }, function (err) {
      resolve({
        error: err.message
      });
    }, {
      timeout: timeout
    });
  });
};

exports.getBrowserLocation = getBrowserLocation;

var addressFromGeoLocation = function addressFromGeoLocation(apiURL, axiosInstance, body) {
  return new Promise(function (resolve) {
    axiosInstance.post(apiURL, body).then(function (response) {
      var responseData = response === null || response === void 0 ? void 0 : response.data;

      if (responseData) {
        resolve(responseData);
      } else {
        resolve({
          error: "response error ".concat(response)
        });
      }
    }).catch(function (err) {
      resolve({
        error: err
      });
    });
  });
};

exports.addressFromGeoLocation = addressFromGeoLocation;

var getAddressUsingIP = function getAddressUsingIP(apiURL, axiosInstance, mapsKey) {
  return new Promise(function (resolve) {
    axios_1.default.post("".concat(Enums_1.ApiUrl.GOOGLE_MAPS).concat(mapsKey)).then(function (response) {
      if ((0, typeHelpers_1.isAxiosError)(response)) {
        throw response;
      }

      var responseData = response === null || response === void 0 ? void 0 : response.data;
      var _responseData$locatio = responseData.location,
          lat = _responseData$locatio.lat,
          lng = _responseData$locatio.lng;
      var requestBody = {
        Latitude: lat,
        Longitude: lng
      };
      resolve((0, exports.addressFromGeoLocation)(apiURL, axiosInstance, requestBody));
    }).catch(function (err) {
      resolve({
        error: err
      });
    });
  });
};

exports.getAddressUsingIP = getAddressUsingIP;
var GeoLocationUtilities = {
  getAddressUsingIP: exports.getAddressUsingIP,
  addressFromGeoLocation: exports.addressFromGeoLocation,
  getBrowserLocation: exports.getBrowserLocation
};
exports.default = GeoLocationUtilities;